import { useState, useEffect } from 'react';
import api from '../lib/api';
import { Input } from '../components/ui/input';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/ui/table';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { Search, FileText } from 'lucide-react';

export default function AuditLogPage() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterType, setFilterType] = useState('all');
  const [filterAction, setFilterAction] = useState('all');
  const [search, setSearch] = useState('');

  useEffect(() => { api.get('/audit').then(r => { setData(r.data); setLoading(false); }).catch(() => setLoading(false)); }, []);

  const filtered = data.filter(l => (filterType === 'all' || l.entity_type === filterType) && (filterAction === 'all' || l.action === filterAction) && (l.user_id.toLowerCase().includes(search.toLowerCase()) || l.entity_id.toLowerCase().includes(search.toLowerCase())));
  const entityTypes = [...new Set(data.map(l => l.entity_type))];
  const actions = [...new Set(data.map(l => l.action))];

  return (
    <div data-testid="audit-page">
      <div className="page-header">
        <div><h1 className="page-title">Audit Log</h1><p className="text-sm text-slate-500 mt-1">{data.length} log entries</p></div>
      </div>

      <div className="flex gap-3 mb-4 flex-wrap">
        <div className="relative max-w-sm"><Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" /><Input placeholder="Search by user or entity..." value={search} onChange={e => setSearch(e.target.value)} className="pl-9 bg-white border-slate-200" data-testid="search-audit" /></div>
        <Select value={filterType} onValueChange={setFilterType}><SelectTrigger className="w-40 bg-white"><SelectValue placeholder="Entity Type" /></SelectTrigger><SelectContent><SelectItem value="all">All Types</SelectItem>{entityTypes.map(t => <SelectItem key={t} value={t}>{t}</SelectItem>)}</SelectContent></Select>
        <Select value={filterAction} onValueChange={setFilterAction}><SelectTrigger className="w-40 bg-white"><SelectValue placeholder="Action" /></SelectTrigger><SelectContent><SelectItem value="all">All Actions</SelectItem>{actions.map(a => <SelectItem key={a} value={a}>{a}</SelectItem>)}</SelectContent></Select>
      </div>

      <div className="data-table-wrapper">
        <Table>
          <TableHeader><TableRow className="bg-slate-50 border-b border-slate-200">
            <TableHead className="text-xs font-semibold uppercase tracking-wider text-slate-500">Timestamp</TableHead>
            <TableHead className="text-xs font-semibold uppercase tracking-wider text-slate-500">Action</TableHead>
            <TableHead className="text-xs font-semibold uppercase tracking-wider text-slate-500">Entity</TableHead>
            <TableHead className="text-xs font-semibold uppercase tracking-wider text-slate-500">Entity ID</TableHead>
            <TableHead className="text-xs font-semibold uppercase tracking-wider text-slate-500">User</TableHead>
            <TableHead className="text-xs font-semibold uppercase tracking-wider text-slate-500">Details</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {loading ? <TableRow><TableCell colSpan={6} className="text-center py-8 text-slate-400">Loading...</TableCell></TableRow> :
            filtered.length === 0 ? <TableRow><TableCell colSpan={6} className="text-center py-8 text-slate-400">No logs found</TableCell></TableRow> :
            filtered.map(l => (
              <TableRow key={l.log_id} className="hover:bg-slate-50/50">
                <TableCell className="text-xs text-slate-500 whitespace-nowrap">{new Date(l.timestamp).toLocaleString()}</TableCell>
                <TableCell><span className="text-xs font-medium bg-slate-100 text-slate-700 px-2 py-0.5 rounded">{l.action}</span></TableCell>
                <TableCell className="text-sm text-slate-600 capitalize">{l.entity_type}</TableCell>
                <TableCell className="font-mono text-xs text-slate-500">{l.entity_id}</TableCell>
                <TableCell className="font-mono text-xs text-slate-600">{l.user_id}</TableCell>
                <TableCell className="text-xs text-slate-400 max-w-xs truncate">{l.details && Object.keys(l.details).length > 0 ? JSON.stringify(l.details) : '-'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
